import { expose } from 'comlink';
import { db as dexieDb } from './db';
import { processMembersData } from './processMembersData';

const exports = {
  processMembersData,
};

export type WebWorker = typeof exports;

export const db = dexieDb;

// Expose method from Comlink make exposed values from one thread available in the other.
// The expose method can be viewed as the Comlink equivalent of export.
// It is used to export the RPC style signature of our worker.
// eslint-disable-next-line no-restricted-globals
expose(exports, undefined, [self.location.origin, /.*\.rocketlane\.com/, '']);
